declare let mxStyleChange: any; // available globally
import * as _ from 'lodash';

export function lineTextGraphChange(graph, cell, change) {
  if (change instanceof mxStyleChange) {
    return null;
  }

  const geometry = cell.geometry;
  const text = graph.getEditingValue(cell);

  const action = {
    flowlineMxKey: +cell.parent.id,
    key: cell.key,
    text,
    position: {
      x: geometry.x,
      y: geometry.y,
      offset: {
        x: geometry.offset.x,
        y: geometry.offset.y
      }
    }
  };

  return {
    data: _.cloneDeep(action),
    action: 'changeLineText',
    type: 'lineText',
    mxKey: cell.id // this is string in line texts
  };
}
